/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Button from '../Button';

import CloseIcon from '@material-ui/icons/Close';

function Alert(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiAlert elevation={0} variant='filled' {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  snackbar: {
    width: '35%',
  },
  Success: {
    width: '100%',
    backgroundColor: '#66D184',
    borderRadius: 0,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: '#FFFFFF',
  },
  Warning: {
    width: '100%',

    backgroundColor: '#EDB526',
    borderRadius: 0,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: '#FFFFFF',
  },
  Errors: {
    width: '100%',

    backgroundColor: '#E75F5F',
    borderRadius: 0,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: '#FFFFFF',
  },
  undo: {
    color: 'white',
    '&:hover': {
      color: 'white !important',
      background: "rgba(0, 0, 0, 0.04) !important"
  }
}
}));

const cb = () => { }

const ToastMessage = ({ style, textStyle, permanent, message, variant, open, onCloseCallback, onForceCloseCallback, autoHideDuration, unDoCallback, unDoAvailable }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Snackbar
        open={permanent || open}
        autoHideDuration={autoHideDuration || 1000}
        onClose={permanent ? cb : onCloseCallback}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        className={classes.snackbar}
        style={style}
      >
        <Alert
          onClose={onCloseCallback}
          severity={variant}
          icon={false}
          action={
            <React.Fragment>
             {unDoAvailable && 
              <Button className={classes.undo} size="sm" variant="tertiary" onClick={() => {
                unDoCallback()
                onCloseCallback()
              }}>
                UNDO
                </Button>
              }
              {
                !permanent &&
                <IconButton size="small" aria-label="close" color="inherit" onClick={onForceCloseCallback}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }

            </React.Fragment>
            // <IconButton
            //   aria-label='close'
            //   color='inherit'
            //   size='small'
            //   onClick={() => onCloseCallback()}
            // >
            //   <CloseIcon fontSize='inherit' />
            // </IconButton>
          }
          classes={{
            filledSuccess: classes.Success,
            filledWarning: classes.Warning,
            filledError: classes.Errors,
          }}
          style={textStyle}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

ToastMessage.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['success', 'warning', 'error']).isRequired,
  open: PropTypes.bool,
  /** CAllback required to close the popup . it changes open state*/
  onCloseCallback: PropTypes.func,
  unDoCallback: PropTypes.func,
  unDoAvailable: PropTypes.bool,
  permanent: PropTypes.bool,
  textStyle: PropTypes.string
};

ToastMessage.defaultProps = {
  open: false,
  onCloseCallback: undefined,
  unDoCallback: undefined,
  unDoAvailable: false
};
export default ToastMessage;
